import React, { useEffect, useState } from "react";
import { Statistic, Row, Col, PageHeader } from "antd";
import { Auth } from "aws-amplify";
import { Aws } from "../../common/Aws";
import "./Dashboard.scss";
import { useQuery } from "@apollo/react-hooks";
import { Stats } from "../../graphql/stats";
import { useHistory } from "react-router";
import { AnalysisCard } from "./AnalysisCard";
import { AppRating } from "./AppRating";
import { UserRating } from "./UserRating";
import { PostUsageTrends } from "./PostUsageTrends";
import { AppUser } from "./AppUser";
import { Store } from "../../store/Store";
import { observer } from "mobx-react";
import { useAppContext } from "../../components/AppProvider";

export const Dashboard = observer(() => {
  const history = useHistory();

  const { data: { stats } = { stats: {} } } = useQuery<any>(Stats);

  const { me } = useAppContext();

  const [user, setUser] = useState<any>({
    shortName: "FM",
  });

  useEffect(() => {
    Auth.currentUserInfo()
      .then(async (user) => {
        console.log("user", user);
        const name = `${user.attributes["given_name"]} ${user.attributes["family_name"]}`;
        setUser({
          name,
          shortName: name
            .split(" ")
            .map((x) => x[0])
            .join("")
            .toUpperCase(),
          roleName: await Aws.getRoleName(),
        });
      })
      .catch(() => {
        history.push("/login");
      });
  }, []);

  return (
    <div className="dashboard">
      <PageHeader
        title={
          <div className="user-wrap">
            <span className="user-avatar">{user.shortName}</span>
            <div className="user-info">
              <div className="username">Hello, {user.name || ""}</div>
              <div className="rolename">{me.title}</div>
            </div>
          </div>
        }
        extra={
          <div className="extra-content" style={{ display: "none" }}>
            <Row justify="end">
              <Col span={3}>
                <Statistic
                  title={
                    <span>
                      region <br /> count
                    </span>
                  }
                  value={stats.regionCount || 0}
                />
              </Col>
              <Col span={4}>
                <Statistic
                  title={
                    <span>
                      division <br /> count
                    </span>
                  }
                  value={stats.divisionCount || 0}
                />
              </Col>
              <Col span={4}>
                <Statistic
                  title={
                    <span>
                      community <br /> count
                    </span>
                  }
                  value={stats.communityCount || 0}
                />
              </Col>
              <Col span={4}>
                <Statistic
                  title={
                    <span>
                      active user <br />/ total users
                    </span>
                  }
                  value={stats.activeUser}
                  suffix={`/ ${stats.totalUser || 0}`}
                />
              </Col>
              <Col span={5}>
                <Statistic
                  title={
                    <span>
                      MTD app rating <br /> / ITD app rating
                    </span>
                  }
                  value={Math.round(stats.mtdRating * 100 || 0) / 100}
                  suffix={`/ ${Math.round(stats.itdRating * 100 || 0) / 100}`}
                />
              </Col>
              <Col span={4}>
                <Statistic
                  className="no-line"
                  title={
                    <span>
                      un-resolved <br /> feedback
                    </span>
                  }
                  value={stats.feedback || 0}
                />
              </Col>
            </Row>
          </div>
        }
      />
      {Store.isAdmin && (
        <div style={{ margin: "40px 80px" }}>
          <Row className="statistic">
            <Col span={4}>
              <Statistic title="Communities" value={"-"} />
            </Col>
            <Col span={4} offset={1}>
              <Statistic title="Members" value={"-"} />
            </Col>
            <Col span={4} offset={1}>
              <Statistic title="DAU" value={"-"} />
            </Col>
            <Col span={4} offset={1}>
              <Statistic title="Service / All" value={"-/-"} />
            </Col>
            <Col span={4} offset={1}>
              <Statistic title="Community Posts" value={"-"} />
            </Col>
          </Row>
          <AppUser />

          <AnalysisCard title="User Peer Comparison" onStart={() => {}}>
            {" "}
          </AnalysisCard>
          <AppRating></AppRating>
          <UserRating></UserRating>
          <PostUsageTrends />

          <AnalysisCard title="ParentShare Usage thrends" onStart={() => {}}>
            {" "}
          </AnalysisCard>
        </div>
      )}
    </div>
  );
});
